




import Vue from "vue";
import store from "@/store";
import { DataModules } from "@/store/modules/data";
import { QUERY_PARAMS } from "@/data/constants";
import { Component } from "vue-property-decorator";

@Component
export default class OpenAddEditGatewayModal extends Vue {
  public created() {
    let gatewayProviderId = "";
    try {
      gatewayProviderId = this.$route.query[
        QUERY_PARAMS.GATEWAY_PROVIDER_ID
      ] as string;

      this.$router.replace({
        query: this.$_.omit(this.$route.query, [
          QUERY_PARAMS.GATEWAY_PROVIDER_ID
        ]),
        name: "brandPaymentProvidersSettings"
      });
    } catch {
      // mask error
    }

    store.dispatch(`data/${DataModules.GATEWAYS}/openManageGateway`, {
      gatewayProviderId,
      ...this.$props
    });
  }
}
